<!--
 Filter Panel component consisting of a b-collapse containing various fields for searching within the plant table
 Props: 
    isVisible -> to expand/collapse the panel; 
    type -> to distinguish between 'zoneBluetooth' and the other kind of visualization
 Emits: 
    'esegui' -> ask the parent to do the search using the fields filled by the users (filters); 
    'close' -> ask the parent to close the collapse and pass 'filters' 
-->
<template>
    <hide-at :breakpoints="{ small: 767, medium: 768, large: 1024 }" breakpoint="small">
        <b-collapse 
            id="collapse-filter-panel" 
            v-model="isVisible" 
            style="margin-top: 130px;" 
            class="filter-panel-aligned"
        >
            <b-card header="" header-bg-variant="primary" border-variant="primary"
                header-text-variant="white" class="mt-2 mb-0 typo-label" :body-class="'pl-3'">

                <template v-slot:header>
                    <span>{{ _self.$t('filter.advanced') }}</span>
                    <b-button size="sm" variant="primary" @click="hideFilters()"
                        class="float-right"><i class="fa fa-close"></i></b-button>
                </template>

                <b-row class="d-flex flex-nowrap">
                    <!-- Central ID, Central Desc, Type of Central -->
                    <b-col v-if="type !== 'zoneBluetooth'" class="px-3 pt-2">
                        <b-form-group :label="$t('filter.central_ID')" label-for="flt-idCentrale">
                            <b-input-group>
                                <b-form-input 
                                    type="text" 
                                    id="flt-idCentrale"
                                    v-model="filters.idCent"
                                    @keyup.enter="invia(false)"
                                >
                                </b-form-input>
                                <b-input-group-append v-if="filters.idCent">
                                    <b-button variant="otuline-secondary" size="sm" @click="filters.idCent = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('filter.central_name')" label-for="flt-nomeCentrale">
                            <b-input-group>
                                <b-form-input 
                                    type="text" 
                                    id="flt-nomeCentrale"
                                    v-model="filters.nomeCent"
                                    @keyup.enter="invia(false)"
                                >
                                </b-form-input>
                                <b-input-group-append v-if="filters.nomeCent">
                                    <b-button variant="otuline-secondary" size="sm" @click="filters.nomeCent = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-card class="mt-2 shadow-sm" :header="$t('filter.central_type')" no-body>
                            <b-form-checkbox-group 
                                id="flt-tipoCentrale"
                                name="flt-tipoCentrale" 
                                v-model="filters.tipoCent"
                                class="p-2"                                                                               
                                :options="centtypeOptions"
                                @change="tipoCentChanged"
                                :disabled="this.type === 'zoneBluetooth'"
                                stacked>
                            </b-form-checkbox-group>
                        </b-card>
 
                    </b-col>
                    <!-- Lamp ID, Lamp Desc, Type of lamp -->
                    <b-col class="px-2 pt-2">
                        <b-form-group :label="$t('filter.lamp_ID')" label-for="flt-idLampada">
                            <b-input-group>
                                <b-form-input 
                                    type="text" 
                                    id="flt-idLampada"
                                    v-model="filters.idLamp"
                                    @keyup.enter="invia(false)"
                                >
                                </b-form-input>
                                <b-input-group-append v-if="filters.idLamp">
                                    <b-button variant="otuline-secondary" size="sm" @click="filters.idLamp = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('filter.lamp_name')" label-for="flt-nomeLampada">
                            <b-input-group>
                                <b-form-input 
                                    type="text" 
                                    id="flt-nomeLampada"
                                    v-model="filters.nomeLamp"
                                    @keyup.enter="invia(false)"
                                >
                                </b-form-input>
                                <b-input-group-append v-if="filters.nomeLamp">
                                    <b-button variant="otuline-secondary" size="sm" @click="filters.nomeLamp = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-card class="mt-2 shadow-sm" :header="$t('filter.lamp_type')" no-body>
                            <b-form-radio-group 
                                id="flt-tipoLamp" 
                                :plain="true"
                                v-model="filters.tipoLamp" 
                                :options="lamptypeOptions"
                                class="p-2"                               
                                stacked
                            >
                            </b-form-radio-group>
                        </b-card>

                    </b-col>
                    <!-- Duration, Mains presence   class="px-1 mt-1"-->
                    <b-col>
                        <b-card class="mt-2 shadow-sm" :header="$t('filter.duration')" no-body>
                            <b-form-checkbox-group 
                                id="flt-autonomia"
                                name="flt-autonomia" 
                                v-model="filters.autonomia"
                                class="p-2"
                                @change="autonomiaChanged" 
                                stacked
                                :options="durationOptions"
                            >
                            </b-form-checkbox-group>
                        </b-card>
                        <b-card class="mt-2 shadow-sm" :header="$t('filter.mains_presence')" no-body>
                            <b-form-radio-group 
                                id="flt-rete" 
                                :plain="true"
                                v-model="filters.rete_se" 
                                :options="mainpresenceOptions"
                                class="p-2" 
                                stacked
                            >
                            </b-form-radio-group>
                        </b-card>
                    </b-col>
                    <!-- Parity, Infinity class="px-1 mt-1"-->
                    <b-col>
                        <b-card class="mt-2 shadow-sm" :header="$t('filter.parity')" no-body>
                            <b-form-radio-group 
                                id="flt-parita" 
                                :plain="true"
                                v-model="filters.parita" 
                                :options="paritaOptions"
                                class="p-2" 
                                stacked
                            >
                            </b-form-radio-group>
                        </b-card>
                        <b-card class="mt-2 shadow-sm" header="Infinity Mode" no-body>
                            <b-form-radio-group 
                                id="flt-infinity" 
                                :plain="true"
                                v-model="filters.infinity" 
                                :options="infinityOptions"
                                class="p-2" 
                                stacked
                            >
                            </b-form-radio-group>
                        </b-card>
                    </b-col>
                    <!-- Line Desc, LSSA Desc, Group Desc -->
                    <b-col v-if="containsSicuroCentral" style="background-color: #ffcc80;" class="px-3 pt-2">
                        <div class="mb-4 mt-2">
                            <h6>{{ $t('filter.sicuro_param') }}</h6>
                        </div>
                        
                        <b-form-group :label="$t('filter.line_desc')" label-for="flt-descLine">
                            <b-input-group>
                                <b-form-input 
                                    id="flt-descLine" 
                                    v-model="filters.descLine"
                                    :disabled="!!filters.descLssa || !!filters.descGroup || type === 'zoneBluetooth'"
                                    @keyup.enter="invia(false)">
                                </b-form-input>
                                <b-input-group-append v-if="filters.descLine">
                                    <b-button size="sm" variant="outline-secondary" @click="filters.descLine = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('filter.lssa_desc')" label-for="flt-descLssa">
                            <b-input-group>
                                <b-form-input 
                                    id="flt-descLssa" 
                                    v-model="filters.descLssa"
                                    :disabled="!!filters.descLine || !!filters.descGroup || type === 'zoneBluetooth'"
                                    @keyup.enter="invia(false)">
                                </b-form-input>
                                <b-input-group-append v-if="filters.descLssa">
                                    <b-button size="sm" variant="outline-secondary" @click="filters.descLssa = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group :label="$t('filter.group_desc')" label-for="flt-descGroup">
                            <b-input-group>
                                <b-form-input 
                                    id="flt-descGroup" 
                                    v-model="filters.descGroup"
                                    :disabled="!!filters.descLine || !!filters.descLssa || type === 'zoneBluetooth'"
                                    @keyup.enter="invia(false)">
                                </b-form-input>
                                <b-input-group-append v-if="filters.descGroup">
                                    <b-button size="sm" variant="outline-secondary" @click="filters.descGroup = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>                    
                    <!-- Zone Desc, Zone Number -->
                    <b-col v-if="type === 'zoneBluetooth'" style="background-color: #e3f2fd;" class="px-3 pt-2">
                        <div class="mb-4 mt-2">
                            <h6>{{ $t('filter.ble_zone_param') }}</h6>
                        </div>
                        <b-form-group :label="$t('filter.zone_desc')" label-for="flt-descZone">
                            <b-input-group>
                                <b-form-input 
                                    id="flt-descZone" 
                                    v-model="filters.descZone" 
                                    :disabled="!!filters.numberZone"
                                    @keyup.enter="invia(false)">
                                </b-form-input>
                                <b-input-group-append v-if="filters.descZone">
                                    <b-button size="sm" variant="outline-secondary" @click="filters.descZone = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group :label="$t('filter.zone_number')" label-for="flt-numbZone">
                            <b-input-group>
                                <b-form-input 
                                    id="flt-numbZone" 
                                    v-model="filters.numberZone"
                                    :disabled="!!filters.descZone"
                                    @keyup.enter="invia(false)">
                                </b-form-input>
                                <b-input-group-append v-if="filters.numberZone">
                                    <b-button size="sm" variant="outline-secondary" @click="filters.numberZone = ''" :aria-label="$t('filter.clear_filter')">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>    
                </b-row>

                <b-row class="mt-2">
                    <b-col class="text-right">
                        <b-button size="sm" variant="light" @click="clearFilters(false)"
                            class="mr-4"><i class="fa fa-eraser"></i>
                            {{ this.$t('filter.nofilter') }}</b-button>
                        <b-button size="sm" variant="primary" @click="inviafilter()">
                            <i class="fa fa-filter"></i>
                            {{ this.$t('filter.execute') }}</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-collapse>
    </hide-at>    
</template>

<script>
import { showAt, hideAt } from 'vue-breakpoints'
import { mapGetters } from 'vuex'

export default {
  name: "AdvancedFilter",
  components: {
    showAt,
    hideAt
  },

  props: {
    isVisible: false,
    type: null
  },

  emits: ['esegui', 'close'],

  data()
  {
    return {
        filters: {
            search: '',
            idCent: '',
            nomeCent: '',
            idLamp: '',
            nomeLamp: '',
            tipoCent: ['all'],
            tipoLamp: 'all',
            autonomia: ['all'],
            parita: 'all',
            infinity: 'all',
            rete_se: 'all',
            descLine: '', 
            descLssa: '',
            descGroup: '',
            descZone: '',
            numberZone: ''
        },
    };
  },

  mounted() {
    console.log("AdvancedFilter, type: ", this.type);
  },

  watch: {
    type(newVal) {
        console.log("AdvancedFilter, type changed: ", newVal);
    }
  },

  computed: {
    //Regola:
    //quando si usa $t o this è meglio usare le computed prpperty per evitare dissincronia tra rendering e oggeti software:
    //this o $t potrebbero non essere ancora disponibili quando avviene il rendering

    ...mapGetters(['containsSicuroCentral']),
    //restituisce le opzioni per i tipi di lampada
    lamptypeOptions() {
        return [
            { text: this.$t('all'), value: 'all' },
            { text: 'SE', value: 'SE' },
            { text: 'SA', value: 'SA' },
            { text: 'UV-Oxy', value: 'oxy' },
            { text: 'No UV-Oxy', value: 'no-oxy' },
            { text: 'Illuminazione', value: 'illuminazione' }
        ];
    },
    //restituisce le opzioni per la presenza di rete
    mainpresenceOptions() {
        return  [
            { text: this.$t('all'), value: 'all' },
            { text: this.$t('filter.SE_present'), value: 'SE_ON' },
            { text: this.$t('filter.SE_absent'), value: 'SE_OFF' }
        ];
    },
    //restituisce le opzioni per la parità
    paritaOptions() {
        return  [
            { text: this.$t('all'), value: 'all' },
            { text: this.$t('param_lamp.PARI'), value: 'PARI' },
            { text: this.$t('param_lamp.DISPARI'), value: 'DISPARI' }
        ];
    },
    //restituisce le opzioni per il filtro infinity
    infinityOptions() {
        return  [
            { text: this.$t('all'), value: 'all' },
            { text: this.$t('on'), value: 'ABILITATO' },
            { text: this.$t('off'), value: 'DISABILITATO' }
        ];
    },
    //restituisce le opzioni per i tipi di centrale
    centtypeOptions() {
        return [
            { text: this.$t('all'), value: 'all' },
            { text: 'Cablecom', value: 'cablecom' },
            { text: 'Logica', value: 'logica' },
            { text: 'LogicaFM', value: 'logicafm' },
            { text: 'Sicuro', value: 'sicuro' },
            { text: 'BleGateway', value: 'blegateway'}
        ];
    },
    //restituisce le opzioni per i tipi di autonomia
    durationOptions() {
        return [
            { text: this.$t('all'), value: 'all' },
            { text: '1H', value: '1H' },
            { text: '1H5', value: '1H5' },
            { text: '2H', value: '2H' },
            { text: '3H', value: '3H' },
            { text: '8H', value: '8H' }
        ];
    }
  },

  methods: {
    //nasconde il collapse
    hideFilters()
    {
        console.log("nascondo filtri avanzati");
        const chiudi = true;
        this.clearFilters(chiudi);
    },
    //azzera i filtri di ricerca nella struttura dati dell'impiantox
    clearFilters(chiusuraModal) {

        this.filters = {
            search: '',
            idCent: '',
            nomeCent: '',
            idLamp: '',
            nomeLamp: '',
            tipoCent: ['all'],
            tipoLamp: 'all',
            autonomia: ['all'],
            rete_se: 'all',
            parita: 'all',
            infinity: 'all',
            descLine: '', 
            descLssa: '',
            descGroup: '',
            descZone: '',
            numberZone: '',
            resettaFiltri: true
        };
        this.invia(chiusuraModal);
    },
    //invio i filtri al componente padre senza chiudere il modal
    inviafilter() {
        this.filters.resettaFiltri = false;
        const chiusuraModal = false;
        this.invia(chiusuraModal);
    },
    //Funzione che viene invocata quando cambia il filtro di tipo centrale
    //in questo caso, se il filtro è vuoto, lo imposto a 'all', altrimenti se è 'all' e ce ne sono altri, lo tolgo
    //se l'ultimo elemento è 'all' e ce ne sono altri, tolgo tutti gli altri e lascio 'all'
    tipoCentChanged(checkedList) {
        
        // checkList è il valore aggiornato passato automaticamente da b-form-checkbox-group
        let currentSelection = [...checkedList];
        //variabile locale
        let nextSelection = currentSelection;

        if (currentSelection.length === 0) {
            // 1. se nulla è selezionato, forzo 'all'
            nextSelection = ['all'];
        }
        else if (currentSelection.includes('all') && currentSelection.length > 1) {
            // 2. Se 'all' era già presente e aggiungo altro, rimuovo 'all'
            if (currentSelection[0] === 'all') {
                nextSelection = currentSelection.filter(item => item !== 'all');
            } 
            // 3. se avevo altre cose e seleziono 'all', resetto tutto a 'all'
            else {
                nextSelection = ['all'];
            }           
        }
        //attendiamo che Vue abbia aggiornato il checkbox (eviatiamo incroci con v-model)
        this.$nextTick(() => {
            this.filters.tipoCent = nextSelection;
            console.log("Stato finale forzato:", this.filters.tipoCent);
        });
    },

    //Funzione che viene invocata quando cambia il checkbox di tipo autonomia
    //idem come sopra
    autonomiaChanged(checkeList)
    {
        let currentSelection = [...checkeList];
        let nextSelection = currentSelection;

        if (currentSelection.length === 0) {
            // 1. se nullaè selezionato, forzo 'all'
            nextSelection = ['all'];
        }
        else if (currentSelection.includes('all') && currentSelection.length > 1) {
            // 2. Se 'all' era già presente e aggiungo altro, rimuovo 'all'
            if (currentSelection[0] === 'all') {
                nextSelection = currentSelection.filter(item => item !== 'all'); 
            } 
            // 3. se avevo altre cose e seleziono 'all', resetto tutto a 'all'
            else {
                nextSelection = ['all'];
            }           
        }
        //attendiamo che Vue abbia aggiornato il checkbox (eviatiamo incroci con v-model)
        this.$nextTick(() => {
            this.filters.autonomia = nextSelection;
            console.log("Stato finale forzato:", this.filters.autonomia);
        });

    },
    //invia al genitore la struttura dati con i filtri
    invia(chiudi) {
        if (chiudi) {
            console.log("chiudi con filtri ", this.filters);
            this.$emit('close', {...this.filters});
        } else {
            //passiamo una copia della struttura per evitare il passaggio per riferimento di default
            console.log("esegui con filtro " + {...this.filters});
            this.$emit('esegui', {...this.filters});   
        }       
    }
  }
}

</script>

<style scoped>

/* Rende il tasto X meno pesante visivamente */
.input-group-append .btn-outline-secondary {
    border-color: #ced4da;
    background-color: white;
    color: #6c757d;
}

.input-group-append .btn-outline-secondary:hover {
    background-color: #f8f9fa;
    color: #dc3545; /* Diventa rosso al passaggio del mouse */
}
</style>